import { Avatar } from '@chain-zen/ui'
import React from 'react'

import { useGetProviderIconUrl } from './hooks/use-get-provider-icon-url'

interface ELDIconProps {
  provider: string
  size?: number
}

/**
 * The ELD icon component
 */
export const ELDIcon = ({ size = 6, provider }: ELDIconProps) => {
  // Convert size to pixels (assuming the original size 6 meant 24px)
  const sizeInPixels = size * 4
  const wrapperPaddingClass = size <= 4 ? 'p-0.5' : 'p-1'
  const geotabIconUrl = useGetProviderIconUrl('geotab', 'icon')
  const attFleetIconUrl = useGetProviderIconUrl('att-fleet-management', 'icon')

  return (
    <div
      className={`flex items-center justify-center rounded-md border border-gray-200 ${wrapperPaddingClass} dark:border-gray-700`}
    >
      {provider === 'GeoTab' ? (
        <img
          style={{
            height: `${sizeInPixels}px`,
            width: `${sizeInPixels}px`
          }}
          src={geotabIconUrl}
          aria-label="eld-icon"
          alt="ELD icon"
        />
      ) : provider === 'ATTFleetManagement' ? (
        <img
          style={{
            height: `${sizeInPixels}px`,
            width: `${sizeInPixels}px`
          }}
          src={attFleetIconUrl}
          aria-label="eld-icon"
          alt="ELD icon"
        />
      ) : (
        <Avatar src="" name={provider} size={size <= 4 ? '2xs' : 'xs'} />
      )}
    </div>
  )
}
